export const getDefaultLanguages = (): string[] => {
    return ["en"]; // "it",
};
